import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as DownLeftArrow } from '../../../../../../assets/icons/v3/down-left-arrow.svg';
import { ReactComponent as UpRightArrow } from '../../../../../../assets/icons/v3/out.svg';
import BdsActivityPill from '../../../../../../shared/components/v3/BdsActivityPill/BdsActivityPill';
import BdsDivider from '../../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';

import './HabitsData.scss';

export const HabitsData = ({ data }: { data: IHealthReport }) => {
  const { t } = useTranslation();

  const renderComparisons = (value: number) => {
    if (data.isFirstReport) return;
    if (value >= 0) {
      return (
        <BdsActivityPill
          variant="filled"
          className="hd-pill positive"
          pictogram={{ component: UpRightArrow }}
          label={<div>{value + '%'}</div>}
        />
      );
    }
    return (
      <BdsActivityPill
        variant="filled"
        className="hd-pill negative"
        pictogram={{ component: DownLeftArrow }}
        label={<div>{Math.abs(value) + '%'}</div>}
      />
    );
  };

  return (
    <div className="habits-data-container">
      <div className="health-report-section-subtitle">{t(TRANSLATIONS_REPORTS.healthReport.habitsData.title)}</div>
      <div className="hd-info">
        <div className="hd-info-item">
          <div className="hd-info-value">{data.activityData.averageSteps}</div>
          <div className="hd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.habitsData.stepsLabel)}</div>
          {renderComparisons(data.activityData.averageStepsInsight)}
        </div>
        <div className="hd-info-item">
          <div className="hd-info-value">{data.activityData.averageTrainingMinutes}</div>
          <div className="hd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.habitsData.trainingLabel)}</div>
          {renderComparisons(data.activityData.averageTrainingMinutesInsight)}
        </div>
        <div className="hd-info-item">
          <div className="hd-info-value">{data.activityData.averageMeditationMinutes}</div>
          <div className="hd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.habitsData.meditationLabel)}</div>
          {renderComparisons(data.activityData.averageMeditationMinutesInsight)}
        </div>
      </div>
      <BdsDivider size="s" color="high" />
    </div>
  );
};

export default HabitsData;
